import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress errors from browser extensions (DarkReader, Firefox Reader, etc.)
const originalError = console.error;
console.error = (...args) => {
  const msg = typeof args[0] === 'string' ? args[0] : '';
  if (msg.includes('DarkReader') || msg.includes('__firefox__')) return;
  originalError.apply(console, args);
};

window.addEventListener('error', (e) => {
  if (e.message && (e.message.includes('DarkReader') || e.message.includes('__firefox__'))) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

window.addEventListener('unhandledrejection', (e) => {
  const msg = e.reason?.message || '';
  if (msg.includes('DarkReader') || msg.includes('__firefox__')) {
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
